import Vue from 'vue';
import App from './App.vue';
import router from './router';
import "babel-polyfill";

Vue.config.productionTip = false;

import { parseTime, order_status, to_f, getTotalPages } from "@/util/tools";


import { getCustomerInfoRequest, loginOutCustomerRequest } from "@/public/js/service";


import element from 'element-ui';
import "./assets/element-E92B2B/index.css";

import "./assets/center.scss";
import "./assets/main.scss";
import "./assets/new.css";

Vue.use(element);

Vue.prototype.parseTime = parseTime;
Vue.prototype.to_f = to_f;
Vue.prototype.order_status = order_status;
Vue.prototype.getTotalPages = getTotalPages;

Vue.prototype.table_cell_style = {
  "text-align": "center",
  "border-color": "#dbdbdb",
  position: "relative",
  "background-color": "#fff",
  "border-right": "1px solid #e7e6e4",
};

Vue.prototype.table_header_cell_style = {
  "background-color": "#e7e6e4",
  color: "#000",
  fontSize: "14px",
  fontWeight: "300",
  "text-align": "center",
  padding: "5px 0",
};

Vue.prototype.getCustomerInfoRequest = getCustomerInfoRequest;
Vue.prototype.loginOutCustomerRequest = loginOutCustomerRequest;


Vue.prototype.$message = element.Message;
Vue.prototype.$loading = element.Loading;
Vue.prototype.$notify = element.Notification;


router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  next();
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
